export const POST_VALIDATION_SESSION_KONSELING_REQUEST =
  "POST_VALIDATION_SESSION_KONSELING_REQUEST";
export const POST_VALIDATION_SESSION_KONSELING_SUCCESS =
  "POST_VALIDATION_SESSION_KONSELING_SUCCESS";
export const POST_VALIDATION_SESSION_KONSELING_FAIL =
  "POST_VALIDATION_SESSION_KONSELING_FAIL";
export const POST_VALIDATION_SESSION_KONSELING_RESET =
  "POST_VALIDATION_SESSION_KONSELING_RESET";
